"use client"
import React, { useEffect, useRef, useState } from 'react';
import {Form} from 'react-bootstrap';
import {toast} from 'sonner'
import {useForm} from 'react-hook-form';
import axios from "axios";
import {errorToast, successToast} from "@/src/hooks/toastNotifications.js";
import styled from "styled-components";
import TextInput from "@/src/components/common/ui/input/TextInput";
import Button from "@/src/components/common/ui/buttons/Button";
import reactHtmlParser from 'react-html-parser';
import { devices } from '@/styles/theme/index.jsx';


const FormContact = ({padding, asModal, id, pt, formData, buttonLabel, form_id, interest, career}) => {

  const {register, handleSubmit, formState, reset} = useForm({mode: 'all'});
  const {errors, isSubmitSuccessful} = formState;
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [selectResponseData, setSelectResponseData] = useState(null);
  const [selectUploadMessage, setSelectUploadMessage] = useState('Attach CV');
  const cvRef = useRef()
  const [cv, setCv] = useState(null)

  const onSubmit = async (e) => {

    setIsSubmitting(true); // Show spinner
    try {
      const formData = new FormData(); // Use a different name
      // Loop through all keys in `e` and append to FormData
      Object.entries(e).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      if(cv){
        formData.append('file', cv ? cv : '');

      }
      formData.append('form_id', form_id ? form_id :'contact-form');
      const response = await axios.post(process.env.NEXT_PUBLIC_API_URL + '/api/post-req-data/form-submit', formData);
      setSelectResponseData(response)

      if (response?.data?.result === 'success') {
        // successToast(response?.data?.message);
        reset(); // This will reset the form fields
        setCv('')
        setSelectUploadMessage('Attach CV')
      } else if (response?.data?.result === 'error') {
        errorToast(response?.data?.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      errorToast(err?.message ? err?.message : 'Failed to submit form. Please try again later.');
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    const count = Object.values(errors).length;
    if (count > 0) {
      errorToast('Please fill out the correct inputs');
    }
  };


  useEffect(() => {
    if (selectResponseData?.error) {
      errorToast(selectResponseData.error);
    }
    if (selectResponseData?.data?.result === 'success') {
      successToast(selectResponseData.data?.message);
    }
  }, [selectResponseData]);



  // handleUpload function
  function handleUpload(event) {
    const selectedFile = event.target.files[0];
    setCv(event.target.files[0]);
    if (selectedFile) {
      const fileName = selectedFile.name;
      setSelectUploadMessage(fileName)
      document.querySelector('.gph_upload').classList.add('hide')

    }

  }


  return (<StyledListWithForm pt={pt} id={`${id ? id : 'ListWithForm'}`}

                              className={`list_with_form ${asModal ? 'asModal' : ''} ${padding ? padding : ''} `}>
        <Form className={'form'} onSubmit={handleSubmit(onSubmit, onError)}>
          <input name={'spam_protector'} type="hidden"/>
          <input name={'form_id'} value={'contact-form'} type="hidden"/>


          {
              formData && formData?.length > 0 &&
              formData?.map((e, index) => {
                let fieldName = e?.field_key
                const required = e?.validators?.split(',').map(f => f.trim());
                const requiredField = required?.includes("required");

                return (
                    <>
                      {
                        e?.field_type === 'textArea' ?
                            <TextInput
                                key={index}
                                name={fieldName}
                                as={'textarea'}
                                placeholder={`${e?.placeholder}`}
                                register={register}
                                validation={{
                                  required: requiredField ? `${e?.label} is Required` : false,

                                }}
                                error={errors[fieldName]}
                            />

                            :

                            e?.field_type === 'fileInput'
                                ?

                                <Form.Group className={'form-group upload-file'}>
                                  <input
                                      ref={cvRef}
                                      onInput={handleUpload}
                                      text={selectUploadMessage}
                                      className={'upload_button'}
                                      id={'file-input'}
                                      type="file"
                                      accept="application/pdf"
                                  />
                                </Form.Group>

                                :


                                  fieldName === 'subject' && interest ?
                                    <TextInput
                                        key={index}
                                        name={fieldName}
                                        placeholder={`${requiredField ?e?.placeholder+'*': e?.placeholder}`}
                                        register={register}
                                        value={interest}
                                        validation={{
                                          required: requiredField ? `${e?.label} is Required` : false,
                                        }}
                                        error={errors[fieldName]}
                                    />
                                    :
                                    <TextInput
                                        key={index}
                                        name={fieldName}
                                        placeholder={`${requiredField ?e?.placeholder+'*': e?.placeholder}`}
                                        register={register}

                                        validation={{
                                          required: requiredField ? `${e?.label} is Required` : false,
                                        }}
                                        error={errors[fieldName]}
                                    />




                      }


                    </>
                )
              })
          }


          <div className={`form-group d-inline-block ${career ? 'career-button' : ''}`}>
          <div className={'submit-wrapper d-inline-block'} onSubmit={handleSubmit(onSubmit, onError)} onClick={handleSubmit(onSubmit, onError)}>
              <Button hoverbackground={'white'} hoverColor={'#101825'}  text={buttonLabel ? buttonLabel : 'Submit Message'} margin={'0'} src={'javascript:void()'}/>
            </div>
          </div>

        </Form>
      </StyledListWithForm>
  );
};

const StyledListWithForm = styled.div`
  position: relative;
  
  &.asModal{
    form{
      .form-group{
        &:nth-of-type(2) {
          max-width: calc(100% - 15px);
          flex: 0 0 calc(100% - 15px);
         
        }

        &:nth-of-type(3) {
          max-width: calc(100% - 15px);
          flex: 0 0 calc(100% - 15px);
        }
      }
    }
  }

  form {
    gap: 0;
    .form-group {
      max-width: calc(100% - 15px);
      flex: 0 0 calc(100% - 15px);

      &:nth-of-type(2) {
        max-width: calc(50% - 15px);
        flex: 0 0 calc(50% - 15px);
      }

      &:nth-of-type(3) {
        max-width: calc(50% - 15px);
        flex: 0 0 calc(50% - 15px);
      }
      ${devices.sm}{
        max-width: 100%;
        flex: 0 0 100%;
        &:nth-of-type(2) {
          max-width: 50%;
          flex: 0 0 50%;
          padding-right: 7.5px;
        }

        &:nth-of-type(3) {
          max-width: 50%;
          flex: 0 0 50%;
          padding-left: 7.5px;
        }
      }
    }

    .career-button{
      max-width: calc(60% - 15px);
      flex: 0 0 calc(60% - 15px);
      .dc-btn{
        margin: 10px 0 0 !important;
        @media(max-width: 767px){
          margin-top: 15px !important;
        }
      }
    }
    .upload-file {
      max-width: calc(40% - 15px);
      flex: 0 0 calc(40% - 15px);
      label {
        margin-bottom: 15px;
      }

      ul {
        color: rgba(244, 244, 244, 0.64);
        font-size: 0.65rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem; /* 200% */
        text-transform: capitalize;
        list-style: none;
      }
    }

    ul {
      margin-top: 12px !important;
      list-style: none !important;

      li {
        list-style: none;
      }
    }

    .upload_button {
      position: relative;
      cursor: pointer;
      border: none !important;
      overflow: hidden !important;
      width: 100%;
      height: 40px !important;
      font-size: 0;
      &:after {
        position: absolute;
        inset: 0;
        content: attr(text);
        font-weight: 500;
        font-size: 1rem;         /* 16px */
        line-height: 1.5rem;     /* 24px */
        letter-spacing: 0;
        text-transform: capitalize;
        background: white;
        z-index: 1;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: flex-start;
        width: 100%;
        padding-left: 50px;
      }

      &:before {
        content: "";
        background-image: url('/images/static/upload.svg');
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: 40px;
        position: absolute;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: center;
        z-index: 11;
      }
    }
  }
`;

export default React.memo(FormContact);
